import React, { useCallback, useEffect, useState } from 'react'
import * as R from 'ramda'
import { useHistory, useLocation } from 'react-router-dom'

import { PlanDetailModal } from './planDetailModal'
import { UpdatePlanSubscriptionModal } from './updatePlanSubscriptionModal'
import AccountPlanAndUsageContainer from 'components/AccountPlanAndUsage/container'
import useAxios from 'hooks/useAxios'
import FailedMessage from './FailedMessage'
import constants from 'config/constants'
import useFeatureToggle from 'hooks/useFeatureToggle'
import { isLegacySubscription } from 'libs/billing/legacy-plan'
import { getActiveCoupon } from 'libs/billing/get-active-coupon'

/**
 * @param {object} props
 * @param {object} props.user
 * @param {object} props.billing
 * @param {object} props.latestInvoice
 * @param {object} props.plans
 * @param {boolean} props.hasCard
 */
export function Plans({ user, billing, latestInvoice, plans, hasCard }) {
  const [type, setType] = useState('year')
  const [selectedPlan, setSelectedPlan] = useState({})
  const [isModalOpened, setIsModalOpened] = useState({ primary: false, secondary: false })
  const { enableNewBillingPlan, enableNewPlanCardUI } = useFeatureToggle()
  const history = useHistory()
  const location = useLocation()

  const { data: accountUsageData } = useAxios({
    url: 'billing/usage/',
  })

  const onModalOpened = useCallback((type, selectedPlan = {}) => {
    setIsModalOpened({ primary: type === 'primary', secondary: type === 'secondary' })
    setSelectedPlan(selectedPlan)
  }, [])

  useEffect(() => {
    if (location.search.includes('open_plan_modal=true')) {
      onModalOpened('primary')
    }
    const isChangePlan = R.pathOr(false, ['state', 'changePlan'], location)
    if (isChangePlan) {
      onModalOpened('primary')
    }
  }, [location, onModalOpened])

  function closeModal() {
    setIsModalOpened({ primary: false, secondary: false })
    setSelectedPlan({})
  }
  function onModalClosed() {
    history.replace({ state: { changePlan: false } })
    closeModal()
  }

  const createOnChoosePlanButtonClicked = (plan) => () => {
    onModalOpened('secondary', plan)
  }

  const subscription = billing.subscription
  const { email, first_name, last_name } = user
  const coupon = getActiveCoupon(
    subscription?.coupon,
    subscription?.coupon_end,
    billing.stripe_customer?.coupon,
    billing.stripe_customer?.coupon_end
  )
  const cancellationLink =
    'https://api.simplesat.io/api/rating/fXX_iPsheqdS9KYE3Jw21ffvk4K0NWXO3WpdjT6cf-0/?source=generic_embed' +
    `&customer_email=${email}&customer_first_name=${first_name}&customer_last_name=${last_name}` +
    `&company_name=${user.billing.company_name}&t_plan=${R.path(
      ['plan', 'nickname'],
      subscription
    )}&t_company_id=${user.selected_workspace?.id || ''}`

  return (
    <React.Fragment>
      <AccountPlanAndUsageContainer
        accountUsageData={accountUsageData}
        billing={billing}
        plan={R.prop('plan', subscription)}
        subscription={subscription}
        coupon={coupon}
        onModalOpened={onModalOpened}
        cancellationLink={cancellationLink}
        failedPaymentMessageElement={
          <FailedMessage
            isActiveSubscription={constants.activeSubscriptionStatus.includes(
              R.prop('status', subscription)
            )}
            latestInvoice={latestInvoice}
          />
        }
      />

      <PlanDetailModal
        createOnChoosePlanButtonClicked={createOnChoosePlanButtonClicked}
        userSubscription={subscription}
        isModalOpened={isModalOpened.primary}
        isLegacySubscription={isLegacySubscription(subscription)}
        onChangeType={setType}
        onModalClosed={onModalClosed}
        plans={plans[`${type}ly`]}
        type={type}
        enableNewBillingPlan={enableNewBillingPlan}
        enableNewPlanCardUI={enableNewPlanCardUI}
      />

      <UpdatePlanSubscriptionModal
        hasPaymentInfo={hasCard}
        type={type}
        selectedPlan={selectedPlan}
        isModalOpened={isModalOpened}
        onModalOpened={onModalOpened}
        onModalClosed={onModalClosed}
        coupon={coupon}
        billing={billing}
      />
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/Billing/plans.js